var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8028 13.334H26.2679V10.0899C26.2679 5.61301 22.8296 1.97961 18.5931 1.97961C14.3566 1.97961 10.9183 5.61301 10.9183 10.0899V13.334H9.38338C7.69493 13.334 6.31348 14.7938 6.31348 16.5781V32.7986C6.31348 34.5828 7.69493 36.0427 9.38338 36.0427H27.8028C29.4913 36.0427 30.8727 34.5828 30.8727 32.7986V16.5781C30.8727 14.7938 29.4913 13.334 27.8028 13.334ZM18.5931 27.9324C16.9047 27.9324 15.5232 26.4726 15.5232 24.6883C15.5232 22.9041 16.9047 21.4442 18.5931 21.4442C20.2816 21.4442 21.663 22.9041 21.663 24.6883C21.663 26.4726 20.2816 27.9324 18.5931 27.9324ZM13.9882 13.334V10.0899C13.9882 7.39726 16.0451 5.22372 18.5931 5.22372C21.1411 5.22372 23.198 7.39726 23.198 10.0899V13.334H13.9882Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a5f431ae436e785d695e3008086a80e6.svg";
export { ForwardRef as ReactComponent };